import type { RootState } from '../store';
import type { DecryptedItem } from '../common/types/items';
import { Child } from '../common/types/child';

const getChildren = (state: RootState): DecryptedItem<Child>[] => state.children.children;

const getCurrentChild = (state: RootState): DecryptedItem<Child> | null => state.children.currentChild;

const getStatus = (state: RootState) => state.children.status;

const childSelector = {
  getChildren,
  getCurrentChild,
  getStatus,
};

export default childSelector;
